import { AssetArchivedEvent } from '../event/asset-archived.event';
const assetArchivedProjections = {
    [AssetArchivedEvent.name]: (event, state) => {
        const payload = event.getPayload();
        return {
            ...state,
            archived: payload.archived,
        };
    },
};
export default assetArchivedProjections;
//# sourceMappingURL=asset-archived.projection.js.map